module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticStyle: {
      "page-break-before": "always"
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "P_Heading_1__And__Page_Break",
    attrs: {
      "id": "auto_bookmark_toc_1"
    }
  }, [_c('span', [_vm._v("Authors’ Note")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal__And__Left_Indent"
  }, [_c('span', {
    staticStyle: {
      "font-size": "0.93em"
    }
  }, [_vm._v("THIS IS")]), _vm._v(" book 2 in the "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Crossing Nuwa")]), _vm._v(" series. This series occurs in the Crimson Paradigm world and the "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Darklight")]), _vm._v(" series (Ninestar Press) has Robbie and Theo as cameo characters. Thank you so much for taking the time to enjoy our work. Please visit us at www.dreamersworkshop.com to find out more about the characters and timelines.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-34cb2de7","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/section0004.vue
// module id = 66
// module chunks = 0